import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import { Dropdown } from 'components/v2/Dropdown'
import { FormattedTime } from '@10xLabs/react-web/components/FormattedTime'
import { ArrowCircleRightIcon } from '@10xLabs/react-web/components/Icons/ArrowCircleRight'
import { StyledLink } from 'components/v2/Link'
import { LabelWrapper, Label, ReturnIcon } from 'features/Bookings/components/Service'
import { isEmpty } from 'lodash'
import { ReactElement } from 'react'

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`

const Tr = styled.tr`
  background-color: #ffffff;

  :hover {
    background-color: #f2f2f2;
  }
`

const Td = styled.td`
  padding: 10px;
`

const Wrapper = styled.div`
  margin: -10px 0;
`

const Item = styled.div`
  margin: 10px 0;
`

export const ServicesByRoute = ({ routeServices }: TSFixMe): ReactElement => {
  return (
    <div>
      {routeServices.length > 0 ? (
        <Dropdown toggle={<StyledLink>{routeServices.length}</StyledLink>} noPadding fitContent>
          <Table>
            <tbody>
              {routeServices.map((routeService: TSFixMe, index: number) => {
                return (
                  <Tr key={index}>
                    <Td>{routeService.code}</Td>
                    {routeService.departureTime ? (
                      <Td>
                        <FormattedTime time={routeService.departureTime} noIcon />
                      </Td>
                    ) : null}
                  </Tr>
                )
              })}
            </tbody>
          </Table>
        </Dropdown>
      ) : (
        0
      )}
    </div>
  )
}

export const BaseRuleServices = ({ baseRule }: TSFixMe): TSFixMe => {
  const isAllSegments = baseRule.citySegments.every((citySegment: TSFixMe) => isEmpty(citySegment.routeServices))
  if (isAllSegments) {
    return (
      <div>
        <FormattedMessage id="baseRuleSegments.list.segments.all" defaultMessage="All Services" />
      </div>
    )
  }
  return (
    <Wrapper>
      {baseRule.citySegments.map((citySegment: TSFixMe, index: number) => {
        return (
          <Item key={index}>
            {baseRule.citySegments.length > 1 && (
              <LabelWrapper>
                {index === 0 ? <ArrowCircleRightIcon /> : <ReturnIcon />}
                <Label>
                  <FormattedMessage
                    id="fareRules.list.routes.count"
                    defaultMessage="Route #{routeNumber}"
                    values={{
                      routeNumber: index + 1
                    }}
                  />
                </Label>
              </LabelWrapper>
            )}
            <ServicesByRoute
              routeServices={citySegment.routeServices}
              allRouteServices={citySegment.allRouteServices}
            />
          </Item>
        )
      })}
    </Wrapper>
  )
}
